import { ref, computed } from "vue";
export var LAYOUT_MODE;
(function (LAYOUT_MODE) {
    LAYOUT_MODE["INPUT"] = "input";
    LAYOUT_MODE["SPLIT"] = "split";
    LAYOUT_MODE["VIEWER"] = "viewer";
})(LAYOUT_MODE || (LAYOUT_MODE = {}));
export const useLayoutMode = () => {
    const layoutMode = ref(LAYOUT_MODE.SPLIT);
    const showLeftPanel = computed(() => layoutMode.value !== LAYOUT_MODE.VIEWER);
    const showRightPanel = computed(() => layoutMode.value !== LAYOUT_MODE.INPUT);
    const leftCols = computed(() => layoutMode.value === LAYOUT_MODE.INPUT ? 12 : 5);
    const rightCols = computed(() => layoutMode.value === LAYOUT_MODE.VIEWER ? 12 : 7);
    const setLayoutMode = (mode) => {
        layoutMode.value = mode;
    };
    return {
        layoutMode,
        showLeftPanel,
        showRightPanel,
        leftCols,
        rightCols,
        setLayoutMode,
    };
};
